<template>
  <modal
    name="timelineTutorial"
    transition="nice-modal-fade"
    @before-open="beforeOpen"
    @opened="opened"
    @closed="closed"
    :width="946"
    :height="569"
    :pivotY="0.3"
  >
    <div class="timeline-tutorial">
      <div class="header">
        <span>一分钟上手时间轴操作</span>
        <div class="close icon-popup-close" @click="close"></div>
      </div>
      <div class="body">
        <video
          ref="teachVideo"
          src="https://resources.laihua.com/2022-5-24/aa0242e0-db34-11ec-8bf3-d97f89cb02f4.mp4"
          controls
        ></video>
      </div>
    </div>
  </modal>
</template>
<script>
export default {
  methods: {
    beforeOpen () {

    },
    opened () {
      this.$refs.teachVideo.play();
    },
    closed () {
      this.$refs.teachVideo.pause();
      this.$refs.teachVideo.currentTime = 0;
    },
    close () {
      this.$modal.hide('timelineTutorial');
    }
  }
}
</script>
<style scoped lang="scss">
.timeline-tutorial {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  margin: auto;
  background-color: #ffffff;
  box-shadow: 0px 0px 4px 0px rgba(54, 76, 204, 0.4);
  border-radius: 4px;
  text-align: center;
  padding-bottom: 47px;
}
.header {
  position: relative;
  padding-top: 40px;
  padding-bottom: 20px;
  width: 100%;
  span {
    font-weight: bold;
    font-size: 18px;
    color: #474261;
  }
  .close {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }
}
.body {
  width: 100%;
  height: 438px;
  padding: 0 84px 0;
  box-sizing: border-box;
  video {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/timelineTutorial.vue